import type { WebsiteThemeFavicon } from './hooks/useGetWebsiteTheme';

export function faviconSize(variant: string): number {
  const size = parseInt(variant, 10);
  return Number.isNaN(size) ? 0 : size;
}

export function sortFaviconsBySizeDesc(favicons: WebsiteThemeFavicon[]): WebsiteThemeFavicon[] {
  return [...favicons].sort((a, b) => faviconSize(b.variant) - faviconSize(a.variant));
}

// The representative icon shown on the theme card and the favicon edit page: the
// largest variant, since the API does not guarantee a particular order.
export function getPrimaryFavicon(
  favicons: WebsiteThemeFavicon[]
): WebsiteThemeFavicon | undefined {
  return sortFaviconsBySizeDesc(favicons)[0];
}
